const color = {
  primary: "#ffffff",
  primary_not_present_in_design: "#e0e4fc",
  primary_medium: "#98989A",
  primary_light: "#B1B1B3",
  primary_dark: "#032e4d",
  accent: "#f28d01",
  accent_dark: "#c07200",
  btn_dark_disabled: "rgba(242, 141, 1, 0.6)",
  secondary: "#054d7f",
  secondaryDark: "#d1d6e1",
  black: "#343a40",
  white: "#ffffff",
  red: "#ff0000",
  green: "#77DD77",
  yellow: "#FDFD96",
  orange: "#F28D01",
  textPrimary: "rgba(0, 0, 0, 0.87)",
  textSecondary: "rgba(0, 0, 0, 0.54)",
  textDisabled: "rgba(0, 0, 0, 0.38)",
  textHint: "rgba(0, 0, 0, 0.38)",
  backgroungOfMyQuestionTable: "rgba(242, 141, 1, 0.12)",
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray900: "#111827",
  green50: "#f0fdf4",
  green200: "#bbf7d0",
  green700: "#15803d",
  blue50: "#eff6ff",
  blue200: "#bfdbfe",
  blue700: "#1d4ed8",
  yellow50: "#fefce8",
  yellow200: "#fef08a",
  yellow700: "#a16207",
  red50: "#fef2f2",
  red200: "#fecaca",
  red600: "#dc2626",
  red700: "#b91c1c",
  orange50: "#fff7ed",
  orange200: "#fed7aa",
  orange500: "#f97316",
  orange600: "#ea580c",
};

export default color;
